import React from 'react';
import { actions } from './Dialog';
import { InfoMessage } from './texts';
import Button from '@material-ui/core/Button';
import Dialog from '../../BuildingBlocks/Dialogs/DialogStyleTwo/Dialog';

export default function AdjustMyRemittanceSchedule({
  setOptionNumber,
  open,
  endRequest,
}) {
  const header = 'Update Sale Pace Forecast';

  const content = `This request will result in the recalculation of remittances to align with the actual sales pace and cash flow. Your Active Growth Plan will remain in effect until you approve any change.`;

  const action = (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={() => setOptionNumber(actions.uploadFileSubmit)}
      >
        <b>Continue</b>
      </Button>
    </>
  );

  return (
    <Dialog
      open={open}
      header={header}
      description={content}
      actions={action}
      onClose={endRequest}
      info={InfoMessage}
    />
  );
}
